import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

function HandlebearsEmptySearchResults({ t }) {
  return (
    <script id="empty-template" type="text/x-handlebars-template">
      <div className="EmptyMessage">{t('global.Empty search result')}</div>
    </script>
  );
}

HandlebearsEmptySearchResults.propTypes = { t: PropTypes.func.isRequired };

export default translate(HandlebearsEmptySearchResults);
